import React, { useLayoutEffect, useRef, FunctionComponent } from 'react';
import { MetaTagsList } from './MetaTagsList';
import { useQueryMetaTags } from '../hooks/useQueryMetaTags';

interface Props {
  requestUrl: string;
  queryOptions?: any;
  translate?(key: string): string;
  format?(html: string): string;
}

export const MetaTags: FunctionComponent<Props> = ({
  requestUrl,
  queryOptions,
  translate = key => key,
  format = html => html,
}) => {
  const { isSuccess, data } = useQueryMetaTags(requestUrl, queryOptions);

  const title = useRef<string>('');

  // Save HOST`s title for return it after leaving the service
  useLayoutEffect(() => {
    title.current = document.title;

    return () => {
      document.title = title.current;
    };
  }, [data]);

  // @ts-ignore
  return isSuccess ? <MetaTagsList data={data} translate={translate} format={format} /> : null;
};
